<template>
  <div class="gui-flex gui-flex-rows">
    <v-dialog
        v-model="dialogSale"
        max-width="550px"
        transition="dialog-transition"
        v-if="dialogSale"
      >
      <v-card class="no__padding">
        <v-card-title class="pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
          <h2>Sleva objednávky</h2>
        </v-card-title>
        <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
          <v-layout row wrap align-end>
            <v-flex xs12>
              <v-text-field
                label="Zadejte slevu na 1 ks"
                suffix="Kč"
                class="mx-2"
                type="number"
                v-model="polozkaCena.sleva"
                @input="(e) => { var sleva = polozkaCena.sleva != null && polozkaCena.sleva.length > 0 ? parseFloat(polozkaCena.sleva) : 0; polozkaCena.cena_po_sleve = parseFloat(polozkaCena.prodejni_cena) - sleva; }"
                :rules="[ (e) => !e || parseFloat(e) <= mozna_sleva.max_sleva || 'Překročena maximální sleva.' ]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="parseFloat(polozkaCena.sleva) <= mozna_sleva.max_sleva">
              <p class="mx-2">Bude odečteno <strong v-html="computeDiscountCredits(polozkaCena.sleva, mozna_sleva)"></strong> kr.</p>
              <p class="mx-2">Cena po slevě za 1 ks: <strong>{{polozkaCena.cena_po_sleve | formatMoney}} {{polozkaCena.mena.zkratka}}</strong></p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions claas="pa-0 mt-3" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
          <v-spacer></v-spacer>
          <v-btn color="primary elevation-0" dark @click="ulozitSlevu" v-if="!polozkaCena.sleva || parseFloat(polozkaCena.sleva) <= mozna_sleva.max_sleva && polozkaCena.cena_po_sleve > 0"><v-icon class="mr-2">save</v-icon>Uložit</v-btn>
          <v-btn color="grey elevation-0 lighten-3" @click="dialogSale=false">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogCreate"
      max-width="1200px"
      transition="dialog-transition"
      v-if="dialogCreate"
    >
      <v-card class="no__padding">
        <v-card-title class="pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
          <h2 v-if="!editMode">Vytvořit novou objednávku</h2>
          <h2 v-else>Upravit objednávku</h2>
        </v-card-title>
        <v-card-text class="pa-0 mt-0">
          <v-form ref="createForm" v-model="valid" lazy-validation>
            <v-layout row wrap>
              <!-- <v-flex xs12 sm3>
                <meny-radio v-model="newItem.mena_id" class="mt-2 mx-2 ml-3" @changed="(e) => { newItem.mena = e; }" :disabled="editMode"></meny-radio>
              </v-flex> -->
              <v-flex xs12 sm3>
                <zpusoby-doruceni v-model="newItem.zpusob_doruceni" class="mt-2 mx-2" :rules="rulesRequiredDoruceni" @changed="(e) => { postovne_vyber = e.postovne; computeTotal(); }"></zpusoby-doruceni>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-2 mb-2">
              <v-flex xs12 sm6>
                <h4 class="mx-3">Fakturační adresa:</h4>
                <vyber-adresy v-model="newItem.fakturacni_adresa" :client="klient" class="mt-2" label="Vybrat adresu" :rules="true" :fakturacni="true" :selectFirst="true"></vyber-adresy>
              </v-flex>
              <v-flex xs12 sm6>
                <h4 class="mx-3" :class="{'mt-2': $vuetify.breakpoint.smAndDown}">Dodací adresa:</h4>
                <vyber-adresy v-model="newItem.dodaci_adresa" :client="klient" class="mt-2" label="Vybrat adresu" :dorucovaci="true" :selectFirst="true"></vyber-adresy>
              </v-flex>
            </v-layout>
            <v-card color="grey lighten-4 mx-3 mt-4 elevation-0">
              <h4 class="mx-0">Produkty v objednávce:</h4>
              <v-card class="pa-0 pt-2 mt-3">
                <productsearch label="Vyhledat produkt" class="mt-0" @changed="productChanged" :clearOnSelect="true" :no-limit="true"></productsearch>
              </v-card>
              <v-data-table
                :headers="newHeaders"
                :items="newItems"
                hide-actions
                class="mt-2"
              >
                <template slot="items" slot-scope="props">
                  <tr>
                    <td>
                      <eshop-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank">{{props.item.produkt.nazev}}</eshop-link>
                      <v-tooltip bottom small>
                        <v-chip slot="activator" color="grey lighten-3 ml-3">K</v-chip>
                        {{props.item.produkt.kredity_jednorazovy_nakup}} kr.
                      </v-tooltip>
                      <v-btn color="grey lighten-3 btn-tiny" small fab depressed  @click="(e) => { slevaClick(props.item); }" v-if="!props.item.produkt.locked">S</v-btn>
                    </td>
                    <td class="text-xs-right">
                      <div v-if="!props.item.produkt.locked">
                        <p v-for="(cena, n) in props.item.ceny" class="text-xs-right mt-3" :class="{ 'mb-1': cena.sleva>0 }" xs4 :key="'produkt-' + props.item.produkt.id.toString() + '-prodejni-cena-' + n.toString()" v-if="cena.mena.id==newItem.mena_id">
                          {{cena.prodejni_cena | formatMoney}} {{cena.mena.zkratka}}
                        </p>
                        <p v-for="(cena, n) in props.item.ceny" class="text-xs-right mt-0 pt-0 red--text" xs4 :key="'produkt-' + props.item.produkt.id.toString() + '-prodejni-cena-' + n.toString()" v-if="cena.mena.id==newItem.mena_id && cena.sleva>0">
                          - {{cena.sleva | formatMoney}} {{cena.mena.zkratka}}
                        </p>
                      </div>
                      <div v-else>
                        <p  class="text-xs-right mt-3" xs4 :key="'produkt-' + props.item.produkt.id.toString() + '-prodejni-cena-'" v-if="props.item.produkt.locked">
                          {{props.item.castka_mj | formatMoney}} {{props.item.mena.zkratka}}
                        </p>
                      </div>
                    </td>
                    <td>
                      <v-text-field
                        type="number"
                        class="mt-3 pt-0"
                        v-model="props.item.pocet"
                        reverse
                        :rules="rulesRequiredMoreThanZero"
                        @input="limitDiscount(props.item);computeTotal();"
                      ></v-text-field>
                    </td>
                    <td class="text-xs-right">
                      <div v-if="!props.item.produkt.locked">
                        <p v-for="(cena, n) in props.item.ceny" class="text-xs-right mt-3" xs4 :key="'produkt-' + props.item.produkt.id.toString() + '-prodejni-cena-' + n.toString()" v-if="cena.mena.id==newItem.mena_id && !props.item.produkt.locked">
                          <span v-html="computePrice(cena.cena_po_sleve, props.item.pocet)"></span>&nbsp;{{cena.mena.zkratka}}
                        </p>
                      </div>
                      <div v-else>
                        <p class="text-xs-right mt-3" xs4 :key="'produkt-' + props.item.produkt.id.toString() + '-prodejni-cena-celkem'">
                          <span v-html="computePrice(props.item.castka, props.item.pocet)"></span>&nbsp;{{props.item.mena.zkratka}}
                        </p>
                      </div>
                    </td>
                    <td>
                      <v-layout row>
                        <v-flex>
                          <v-btn color="white lighten-3" depressed fab small @click="newItems.splice(newItems.indexOf(props.item), 1);computeTotal();"><v-icon>delete</v-icon></v-btn>
                        </v-flex>
                      </v-layout>
                    </td>
                  </tr>
                </template>
                <template slot="footer">
                  <tr>
                    <td><span>Poštovné:</span></td>
                    <td colspan="5" class="text-xs-right">
                      <span v-if="postovne!=null">{{postovne.cena | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span></span>
                      <span v-else>--</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Celkem bez DPH:</td>
                    <td colspan="5" class="text-xs-right">
                      {{newItemCelkem.bez_dph | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span>
                    </td>
                  </tr>
                  <tr v-if="newItemCelkem.dph_10>0">
                    <td>DPH 10%</td>
                    <td colspan="5" class="text-xs-right">
                      {{newItemCelkem.dph_10 | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span>
                    </td>
                  </tr>
                  <tr v-if="newItemCelkem.dph_15>0">
                    <td>DPH 15%</td>
                    <td colspan="5" class="text-xs-right">
                      {{newItemCelkem.dph_15 | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span>
                    </td>
                  </tr>
                  <tr v-if="newItemCelkem.dph_21>0">
                    <td>DPH 21%</td>
                    <td colspan="5" class="text-xs-right">
                      {{newItemCelkem.dph_21 | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Celkem s DPH:</strong></td>
                    <td colspan="5" class="text-xs-right">
                      <strong>{{newItemCelkem.s_dph | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span></strong>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
            <v-card color="grey lighten-4 mx-3 mt-4 elevation-0">
              <v-textarea
                class="mx-3"
                label="Poznámka k objednávce"
                height="60"
                v-model="newItem.poznamka"
              ></v-textarea>
            </v-card>
            <div class="pa-3 pl-4 red--text" v-if="preneseni_dan_povinnost_invalid_1">
              Souhrn částky produktů stříbra bez zvláštního režimu DPH musí být menší než 95 000 Kč.
            </div>
            <div class="pa-3 pl-4 red--text" v-if="preneseni_dan_povinnost_invalid_2">
              Souhrn částky produktů stříbra bez zvláštního režimu DPH musí být menší než 95 000 Kč.
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-0 mt-3" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-3 elevation-0" dark @click="create" v-if="!editMode && newItems.length > 0" :loading="creating">Vytvořit</v-btn>
          <v-btn color="blue darken-3 elevation-0" dark @click="edit" v-else-if="newItems.length > 0" :loading="creating">Upravit</v-btn>
          <v-btn color="grey lighten-3 elevation-0 mr-2" @click="close" v-if="!creating">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/*import RocniBonusy from '@/pages/Klienti/RocniBonusy'
import Platby from '@/pages/Klienti/Platby'
import PredaneProdukty from '@/pages/Klienti/PredaneProdukty'*/
export default {
  data () {
    return {
      dialogDetail: true,
      dialogSale: false,
      loading: false,
      loadingTable: false,
      editMode: false,
      activeTab: 0,
      tabs: [ 'informace', 'platby', 'rocni_bonusy', 'graf_sporeni', 'predane_produkty' ],
      item: {},
      newItems: [],
      updating: false,
      newHeaders: [
        { text: "Produkt", value: "produkt", sortable: false },
        { text: "Cena MJ", value: "ceny", sortable: false, width: 150, align: "right" },
        { text: "Počet", value: "pocet", sortable: false, width: 150, align: "right" },
        { text: "Cena celkem", value: "ceny", sortable: false, width: 150, align: "right" },
        { text: "", value: "", sortable: false, width: 60, align: "right" },
      ],
      items: [],
      tab: 1,
      dialogCreate: false,
      newItem: null,
      mena: null,
      newItemCelkem: { bez_dph: 0, s_dph: 0, dph_10: 0, dph_15: 0, dph_21: 0 },
      dialogInit: {
        nazev_sporeni: null,
        cilova_castka: null,
        mesicni_platba: null,
        prvni_platba: null,
        datum_sjednani: null,
        mena: null,
        mena_id: 1,
        cilovy_produkt_id: null,
        typ_vstupni_poplatek: "na_zacatku",
        vstupni_poplatek_procento: 0,
        vstupni_poplatek: 0,
        behem_sporeni: 0,
        sporici_produkt_id: null,
        poznamka: "",
        zpusob_doruceni: null
      },
      preneseni_dan_povinnost_invalid_1: false,
      preneseni_dan_povinnost_invalid_2: false,
      search: null,
      sporici_program: null,
      rulesRequired: [
        (e) => !!e || "Pole je vyžadováno"
      ],
      rulesRequiredDoruceni: [
        (e) => (!!e && e != 0 && e.id != 0) || "Pole je vyžadováno"
      ],
      rulesRequiredMoreThanZero: [
        (v) => !!v && v > 0 || "Pole je vyžadováno"
      ],
      valid: true,
      creating: false,
      polozkaCena: null,
      max_sleva: 0,
      mozna_sleva: null,
      postovne_vyber: [],
      postovne: null
    }
  },
  watch: {
    mena () {
      this.newItem.mena = this.mena;
      this.newItem.mena_id = this.mena.id;
      this.loadSporiciProgramy();
    },
    dialogCreate (v) {
      if (!v)
        this.$emit("close");
    }
  },
  props: {
    klient: String,
    edit: Boolean,
    id: String
  },
  mounted: function() {
    if (this.edit) {
      window.API.get("klient/nakupy/" + this.klient + "/jednorazove-nakupy/" + this.id + "/edit").then(function(body) {
        this.newItem = body;
        this.dialogCreate = true;
        this.editMode = true;
        this.newItems = body.polozky;
        this.computeTotal();
      }.bind(this)).catch(function(err) {
      }.bind(this));
    }
    else {
      this.newItem = window.th.copy(this.dialogInit);
      this.dialogCreate = true;
      this.editMode = false;
      this.newItems = [];
      window.API.get("klient/nakupy/" + this.klient + "/jednorazove-nakupy/nastaveni").then(function(body) {
        this.newItem.zpusob_doruceni = body.zpusob_doruceni;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  methods: {
    close () {
      this.$emit('close');
    },
    computeTotal () {
      if (this.newItems != null && this.newItems.length > 0) {
        var mena_id = this.newItem.mena_id;
        this.newItemCelkem.bez_dph = this.newItems.filter((e) => { return !e.produkt.locked; }).map((e) => { var pc = e.ceny.filter((c) => { return c.mena.id == mena_id; }); return pc[0].prodejni_cena_bez_dph * (e.pocet.length > 0 && parseInt(e.pocet) > 0 ? parseInt(e.pocet) : 0); }).reduce((a, b) => { return a + b; }, 0);
        this.newItemCelkem.dph_10 = this.newItems.filter((e) => { return !e.produkt.locked; }).map((e) => { var pc = e.ceny.filter((c) => { return c.mena.id == mena_id; }); return pc[0].sazba_dph == 10 ? (pc[0].prodejni_cena_dph * (e.pocet.length > 0 && parseInt(e.pocet) > 0 ? parseInt(e.pocet) : 0)) : 0; }).reduce((a, b) => { return a + b; }, 0);
        this.newItemCelkem.dph_15 = this.newItems.filter((e) => { return !e.produkt.locked; }).map((e) => { var pc = e.ceny.filter((c) => { return c.mena.id == mena_id; }); return pc[0].sazba_dph == 15 ? (pc[0].prodejni_cena_dph * (e.pocet.length > 0 && parseInt(e.pocet) > 0 ? parseInt(e.pocet) : 0)) : 0; }).reduce((a, b) => { return a + b; }, 0);
        this.newItemCelkem.dph_21 = this.newItems.filter((e) => { return !e.produkt.locked; }).map((e) => { var pc = e.ceny.filter((c) => { return c.mena.id == mena_id; }); return pc[0].sazba_dph == 21 ? (pc[0].prodejni_cena_dph * (e.pocet.length > 0 && parseInt(e.pocet) > 0 ? parseInt(e.pocet) : 0)) : 0; }).reduce((a, b) => { return a + b; }, 0);
        this.newItemCelkem.s_dph = this.newItems.filter((e) => { return !e.produkt.locked; }).map((e) => { var pc = e.ceny.filter((c) => { return c.mena.id == mena_id; }); return pc[0].cena_po_sleve * (e.pocet.length > 0 && parseInt(e.pocet) > 0 ? parseInt(e.pocet) : 0); }).reduce((a, b) => { return a + b; }, 0);
        console.log(this.computingError);

        this.newItemCelkem.bez_dph += this.newItems.filter((e) => { return e.produkt.locked; }).map((e) => { return e.castka_bez_dph * e.pocet; }).reduce((a, b) => { return a + b; }, 0);
        this.newItemCelkem.dph_10 += this.newItems.filter((e) => { return e.produkt.locked; }).map((e) => { return e.castka_dph_10 * e.pocet; }).reduce((a, b) => { return a + b; }, 0);
        this.newItemCelkem.dph_15 += this.newItems.filter((e) => { return e.produkt.locked; }).map((e) => { return e.castka_dph_15 * e.pocet; }).reduce((a, b) => { return a + b; }, 0);
        this.newItemCelkem.dph_21 += this.newItems.filter((e) => { return e.produkt.locked; }).map((e) => { return e.castka_dph_21 * e.pocet; }).reduce((a, b) => { return a + b; }, 0);
        this.newItemCelkem.s_dph += this.newItems.filter((e) => { return e.produkt.locked; }).map((e) => { return e.castka * e.pocet; }).reduce((a, b) => { return a + b; }, 0);

        var celkem_s_dph = this.newItemCelkem.s_dph;
        this.postovne = this.postovne_vyber.filterOne((e) => { return e.mena_id = mena_id && e.cena_objednavky_od <= celkem_s_dph && e.cena_objednavky_do >= celkem_s_dph });
        if (this.postovne != null) {
          this.newItemCelkem.bez_dph += this.postovne.cena_bez_dph;
          this.newItemCelkem.dph_21 += this.postovne.cena - this.postovne.cena_bez_dph;
          this.newItemCelkem.s_dph += this.postovne.cena;
        }
      }
      else {
        this.newItemCelkem = { bez_dph: 0, s_dph: 0, dph_10: 0, dph_15: 0, dph_21: 0 };
      }
    },
    productChanged (e) {
      if (e != null)
        window.API.get("klient/nakupy/produkty/" + e.id + "/ceny").then(function(body) {
          body.forEach((e) => {
            e.cena_po_sleve = parseFloat(e.prodejni_cena);
            e.sleva = null;
          });
          this.newItems.push({ produkt: e, produkt_id: e.id, pocet: "1", ceny: body});
          this.computeTotal();
        }.bind(this)).catch(function(err) {
        }.bind(this));
    },
    computePrice(c, q) {
      //this.computeTotal();
      if (c == null || q == null || c <= 0 || q <= 0)
        return 0;
      return window.th.formatPrice(c*q, 2, ",", " ").replace(" ", "&nbsp;")
    },
    computePartials (p, c) {
      switch (p.zvlastni_rezim) {
        case "neni":
          var dph = parseFloat(c.cena_po_sleve) - (parseFloat(c.cena_po_sleve) / (1 + c.sazba_dph / 100));
          c.prodejni_cena_dph = dph;
          c.prodejni_cena_bez_dph = parseFloat(c.cena_po_sleve) - dph;
          break;
        case "par_90":
          var dph = parseFloat(c.cena_po_sleve) >= c.nakladova_cena ? (parseFloat(c.cena_po_sleve) - c.nakladova_cena - ((parseFloat(c.cena_po_sleve) - c.nakladova_cena) / (1 + c.sazba_dph / 100))) : 0;
          c.prodejni_cena_dph = dph;
          c.prodejni_cena_bez_dph = parseFloat(c.cena_po_sleve) - dph;
          break;
        case "par_92":
          c.prodejni_cena_dph = 0;
          c.prodejni_cena_bez_dph = parseFloat(c.cena_po_sleve);
          break;
      }
      this.computeTotal();
    },
    slevaClick (polozka) {
      this.polozka = polozka;
      var mena_id = this.newItem.mena_id;
      this.polozkaCena = window.th.copy(this.polozka.ceny.filterOne((e) => { return e.mena.id == mena_id; }));
      this.mozna_sleva = null;
      var aktualni_cena = polozka.produkt.aktualni_ceny.filterOne((e) => { return e.mena.id == mena_id });
      if (aktualni_cena != null) {
        var pocet = !isNaN(polozka.pocet) ? parseInt(polozka.pocet) : 0;
        var sleva = aktualni_cena.slevy.filterOne((e) => { return e.mnozstvi_od <= pocet && e.mnozstvi_do >= pocet });
        if (sleva != null) {
          this.mozna_sleva = sleva;
        }
        else {
          this.mozna_sleva = {
            max_sleva: 0,
            kredity: 0,
            kredity_slevy_mj: 1
          }
        }
      }
      else {
        this.mozna_sleva = {
          max_sleva: 0,
          kredity: 0,
          kredity_slevy_mj: 1
        }
      }
      this.dialogSale = true;
    },
    ulozitSlevu () {
      var mena_id = this.newItem.mena_id;
      var f = this.polozka.ceny.filter((e) => { return e.mena.id == mena_id  });
      var i = this.polozka.ceny.indexOf(f[0]);
      this.polozka.ceny[i].sleva = this.polozkaCena.sleva;
      this.polozka.ceny[i].cena_po_sleve = parseFloat(this.polozkaCena.prodejni_cena) - this.polozkaCena.sleva;
      this.polozka.ceny[i].prodejni_cena_dph = parseFloat(this.polozkaCena.prodejni_cena_dph);
      this.computePartials(this.polozka.produkt, this.polozka.ceny[i]);
      this.polozka.produkt.kredity_jednorazovy_nakup = Math.max(this.polozka.produkt.kredity_jednorazovy_nakup_vychozi - parseFloat(this.computeDiscountCredits(this.polozkaCena.sleva, this.mozna_sleva)), 0).toString().replace(",", ".");
      this.dialogSale = false;
    },
    computeDiscountCredits (sleva, mozna_sleva) {
      if (!isNaN(sleva) &&parseFloat(sleva) > 0 && !isNaN(mozna_sleva.kredity) && parseFloat(mozna_sleva.kredity) > 0 && !isNaN(mozna_sleva.kredity_slevy_mj) && parseFloat(mozna_sleva.kredity_slevy_mj) > 0) {
        return parseFloat((parseFloat(sleva) / parseFloat(mozna_sleva.kredity_slevy_mj) * parseFloat(mozna_sleva.kredity)).toFixed(2));
      }
      return 0;
    },
    limitDiscount (p) {
      if (p.produkt.locked)
        return;
      var mena_id = this.newItem.mena_id;
      var max_sleva = 0;
      var aktualni_cena = p.produkt.aktualni_ceny.filterOne((e) => { return e.mena.id == mena_id });
      if (aktualni_cena != null) {
        var pocet = !isNaN(p.pocet) ? parseInt(p.pocet) : 0;
        var sleva = aktualni_cena.slevy.filterOne((e) => { return e.mnozstvi_od <= pocet && e.mnozstvi_do >= pocet });
        if (sleva != null) {
          max_sleva = parseFloat(sleva.max_sleva);
        }
      }
      var cena = p.ceny.filterOne((e) => { return e.mena.id == mena_id; });
      if (!isNaN(cena.sleva)) {
        if (parseFloat(cena.sleva) > max_sleva)
          cena.sleva = max_sleva;
      }
    },
    create () {
      if (this.$refs.createForm.validate()) {
        this.preneseni_dan_povinnost_invalid_1 = false;
        this.preneseni_dan_povinnost_invalid_2 = false;
        var mena_id = this.newItem.mena_id;
        var preneseni_dan_povinnost_castka =  this.newItems.filter((e) => {
          return e.produkt.preneseni_dan_povinnost;
        }).map((e) => { return parseFloat(e.ceny.filterOne((i) => {
          return i.mena.id == mena_id;
        }).prodejni_cena_bez_dph) * parseInt(e.pocet) }).reduce((t, n) => { return t + n; }, 0);
        var polozky_bez_dp = this.newItems.filter((e) => {
          return !e.produkt.preneseni_dan_povinnost;
        }).length;
        if (preneseni_dan_povinnost_castka > 95000) {
          if (preneseni_dan_povinnost_castka >= 105000 && polozky_bez_dp == 0) {
            this.preneseni_dan_povinnost_invalid_2 = false;
          }
          else if (preneseni_dan_povinnost_castka >= 105000 && polozky_bez_dp > 0) {
            this.preneseni_dan_povinnost_invalid_2 = true;
          }
          else {
            this.preneseni_dan_povinnost_invalid_1 = true;
          }
        }
        if (!this.preneseni_dan_povinnost_invalid_1 && !this.preneseni_dan_povinnost_invalid_2) {
          this.sending = true;
          var mena_id = this.newItem.mena_id;
          window.API.post("klient/nakupy/" + this.klient + "/jednorazove-nakupy", {
            datum: this.newItem.datum_sjednani,
            mena_id: this.newItem.mena_id,
            zpusob_doruceni: this.newItem.zpusob_doruceni,
            fa_adresa: this.newItem.fakturacni_adresa,
            dod_adresa: this.newItem.dodaci_adresa,
            variabilni_symbol: this.newItem.variabilni_symbol,
            poznamka: this.newItem.poznamka,
            produkty: this.newItems.map((e) => {
              return {
                id: e.produkt.id,
                mnozstvi: e.pocet,
                cena: e.ceny.filterOne((i) => {
                  return i.mena.id == mena_id;
                }),
                kredity: parseFloat(e.produkt.kredity_jednorazovy_nakup)
              };
            })
          }).then(function(body) {
            if (body.inserted) {
              this.$emit("created");
            }
            this.sending = false;
          }.bind(this)).catch(function(err) {
            console.log(err);
            this.sending = false;
          }.bind(this));
        }
      }
      else {
        var e = this.$refs.createForm.inputs != null && this.$refs.createForm.inputs.length > 0 ? this.$refs.createForm.inputs.filter((e) => { return e.hasError }) : [];
        if (e != null && e.length > 0) {
          e[0].focus();
        }
      }
    }
  },
  components: {
    //RocniBonusy, Platby, PredaneProdukty
  }
}
</script>
